module.exports = __webpack_public_path__ + "img/yd-gd-img.b982afde.png";